import _ from 'lodash';
import { toast } from 'react-toastify';

import LocaleService from '@services/LocaleService';

const translations = LocaleService.getTranslations('general.error');

const errorResponse: {
  [key: number]: any
} = {
  401: translations.invalid_credentials,
  429: translations.throttle,
  422: translations.validation,
  500: translations.internal_server,
};

const parseErrorResponse = (response: any) => {
  // default message
  let message: any = translations.default;
  // means no internet or couldn't establish connection
  if (!response) {
    message = translations.establish_connection;
  } else if (response.status === 422) {
    if (response.data && response.data.message) {
      message = response.data.message;
    } else if (response.data && response.data.errors) {
      message = translations.validation.title;
    } else {
      message = translations.validation.title;
    }
    return {
      message,
      title: translations.validation.title,
      errors: response.data.errors,
      fullResponse: response.data,
    };
  } else if (response.status === 400) {
    // eslint-disable-next-line prefer-destructuring
    message = {
      message: response.data.message,
      title: translations.invalid_request.title,
    };
  } else if (errorResponse[response.status]) {
    // if status code is defined in error response object
    message = errorResponse[response.status];
  }

  return message;
};

export const handleError = (err: any) => {
  // do not show toast if request is cancelled during logout
  if (err?.message === 'Request Cancelled') return;
  const { response } = err;

  const { message } = parseErrorResponse(response);
  // implement display of error here
  toast.error(message);
};

// eslint-disable-next-line no-console
export const logError = (error: any) => console.log('error in request', error);

export const transformErrors = (errors: any) => errors?.reduce((a: any, b: any) => ({
  ...a,
  [b.property]: Object.values(b.constraints).map((v) => _.upperFirst(v as string).replace(/_/g, ' ')),
}), {});
